(() => {
  const root = document.getElementById('tsv-account');
  if (!root) return;

  const trigger = root.querySelector('#tsv-account-trigger');
  const popover = root.querySelector('#tsv-account-popover');
  if (!trigger || !popover) return;

  const isDesktop = () => window.innerWidth >= 990;

  let open = false;

  const show = () => {
    if (!isDesktop()) return;
    if (open) return;
    popover.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    open = true;
  };

  const hide = () => {
    if (!open) return;
    popover.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    open = false;
  };

  const toggle = () => {
    open ? hide() : show();
  };

  trigger.addEventListener('click', (e) => {
    if (!isDesktop()) return;
    e.preventDefault();
    toggle();
  });

  document.addEventListener('click', (e) => {
    if (!isDesktop()) return;
    if (!open) return;
    if (!root.contains(e.target)) hide();
  });

  document.addEventListener('keydown', (e) => {
    if (!isDesktop()) return;
    if (e.key === 'Escape') hide();
  });

  popover.addEventListener('focusin', () => {
    if (!isDesktop()) return;
    show();
  });

  var _haRaf = 0;
  window.addEventListener('resize', () => {
    cancelAnimationFrame(_haRaf);
    _haRaf = requestAnimationFrame(() => { if (!isDesktop()) hide(); });
  });
})();